/**
 * Free Shipping Bar — live update via Spotlight pub/sub system
 *
 * Uses the existing cart-update pub/sub event from assets/pubsub.js.
 * Safety net: the bar is also re-rendered server-side via Section Rendering
 * API on every cart change.
 */

(function () {
  function updateShippingBar(cartData) {
    var bar = document.getElementById('free-shipping-bar');
    if (!bar) return;

    var threshold = parseInt(bar.dataset.threshold, 10);
    // 2026-09-19: guard against threshold being 0/NaN (e.g. a stray or
    // misconfigured data-threshold attribute) — without this, the
    // division below silently produces Infinity/NaN, which then gets
    // written into fill.style.width as an invalid CSS value. Falling
    // back to the documented €55 default (5500 cents) keeps the bar
    // functional instead of silently breaking.
    if (!threshold || isNaN(threshold) || threshold <= 0) {
      threshold = 5500;
    }

    var cartTotal = cartData.total_price || 0;
    var itemCount = cartData.item_count || 0;

    var progress = 0;
    if (cartTotal > 0) {
      progress = Math.min(100, Math.round((cartTotal / threshold) * 100));
    }

    var fill = bar.querySelector('.shipping-bar__fill');
    if (fill) {
      fill.style.width = progress + '%';
      // 2026-09-19: toggle the same modifier class the Liquid template
      // uses server-side, so the colour (orange -> brand mint) updates
      // live without waiting for the Section Rendering API re-render.
      fill.classList.toggle('shipping-bar__fill--complete', cartTotal >= threshold);
    }

    var text = bar.querySelector('.shipping-bar__text');
    if (!text) return;

    if (itemCount === 0) {
      text.textContent = 'Nemokamas pristatymas nuo \u20ac' + (threshold / 100).toFixed(2);
    } else if (cartTotal >= threshold) {
      text.textContent = '\u2713 Nemokamas pristatymas pritaikytas!';
    } else {
      var remaining = ((threshold - cartTotal) / 100).toFixed(2);
      text.textContent = 'Dar \u20ac' + remaining + ' iki nemokamo pristatymo';
    }
  }

  function onCartUpdate(event) {
    if (event.cartData && typeof event.cartData.total_price === 'number') {
      updateShippingBar(event.cartData);
    } else {
      fetch(window.routes ? window.routes.cart_url + '.json' : '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateShippingBar(cart); })
        .catch(function () { /* silent fail */ });
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
})();
